import { render, staticRenderFns } from "./GeneralInfoBlock.vue?vue&type=template&id=9082d136&scoped=true&"
import script from "./GeneralInfoBlock.vue?vue&type=script&lang=js&"
export * from "./GeneralInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInfoBlock.vue?vue&type=style&index=0&id=9082d136&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9082d136",
  null
  
)

export default component.exports